import { Middleware } from "@reduxjs/toolkit";

import { AUTH_TOKEN_HEADER } from "@assets/constants";
import { setAccessTokenExpiryInterval } from "@assets/helpers/token";
import { RootState } from "@state/store";

export const authMiddleware: Middleware<Record<string, unknown>, RootState> =
  () => (next) => (action) => {
    if ("auth/login/fulfilled" === action.type) {
      getTokenAndSetExpiryCheck();
    }

    if ("auth/user_me/fulfilled" === action.type) {
      getTokenAndSetExpiryCheck();
    }

    return next(action);
  };

const getTokenAndSetExpiryCheck = () => {
  const token = localStorage.getItem(AUTH_TOKEN_HEADER);
  if (token) setAccessTokenExpiryInterval(token);
};
